export default __webpack_public_path__ + "static/media/global.102a73c5.svg";